<app-header></app-header>

<bit-container>
  <tools-credential-generator />
</bit-container>
